<template>
	<div @click="enlargement" style="display: inline-block;">
		<slot>
			<img v-show="src" :src="src" />
		</slot>
	</div>

</template>

<script>
	export default {
		props: ['src'],
		data() {

			return {

			}
		},
		methods: {
			enlargement() {
				const h = this.$createElement;
				let vn = !this.src ? this.$slots.default[0] : h('img',{attrs:{'src': this.src }  });

				this.$alert(vn, {
					dangerouslyUseHTMLString: true,
					customClass: 'imgCla',
					showConfirmButton: false,
					closeOnClickModal: true
				}).catch(rsg => {});
			}
		},

	}
</script>

<style>
	.imgCla {
		width: 600px !important;
	}
	
	.imgCla img {
		display: inline-block;
		width: 100%;
	}
</style>